import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

interface BlogMidArticleCTAProps {
  variant?: "default" | "minimal";
}

/**
 * Subtile Mid-Article CTA für HSP-Zielgruppe
 * Platzierung: Nach 60-70% des Artikelinhalts
 * Design: Understatement, warm, nicht verkäuferisch
 */
const BlogMidArticleCTA: React.FC<BlogMidArticleCTAProps> = ({ variant = "default" }) => {
  return (
    <aside 
      className="my-12 not-prose"
      aria-label="Kontaktangebot"
      data-cta-position="mid-article"
    >
      <div className="max-w-2xl mx-auto p-6 rounded-lg border-l-4 border-sage-400 bg-gradient-to-r from-sage-50/80 to-earth-50/60 dark:from-sage-900/20 dark:to-earth-900/15 dark:border-sage-600">
        <div className="flex items-start gap-4">
          <Compass 
            className="w-5 h-5 mt-0.5 text-sage-600 dark:text-sage-400 flex-shrink-0" 
            aria-hidden="true"
          />
          <div className="flex-1">
            <p className="text-sm text-joerg-700 dark:text-joerg-200 leading-relaxed mb-3">
              {variant === "minimal" 
                ? "Wenn dieser Gedanke Sie anspricht, lassen Sie uns sprechen."
                : "Falls Sie beim Lesen gemerkt haben, dass ein strategisches Gespräch Klarheit bringen könnte – ich bin für Sie da."
              }
            </p>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 text-sm font-medium text-sage-700 dark:text-sage-300 hover:text-primary dark:hover:text-primary-light transition-colors underline-offset-4 hover:underline"
              aria-label="Zum Kontaktformular"
            >
              Unverbindliches Gespräch vereinbaren
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default BlogMidArticleCTA;
